"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _ModalFrame = _interopRequireDefault(require("./ModalFrame"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _params = require("hub-http/helpers/params");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UINanoProgress = _interopRequireDefault(require("UIComponents/progress/UINanoProgress"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _UIAbstractProgress = _interopRequireDefault(require("UIComponents/progress/UIAbstractProgress"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _getIframeModalHost = require("ui-addon-upgrades/_core/utils/getIframeModalHost");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 500px;\n  position: relative;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 420px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 500px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function createSource(upgradeData) {
  var app = upgradeData.app,
      screen = upgradeData.screen,
      uniqueId = upgradeData.uniqueId;
  return app + "-" + screen + "-locked-feature-" + uniqueId;
}

function createFrameSrc(upgradeData, modalKey) {
  var app = upgradeData.app,
      screen = upgradeData.screen,
      uniqueId = upgradeData.uniqueId,
      upgradeProduct = upgradeData.upgradeProduct;
  var source = createSource(upgradeData);
  var queryParams = "upgradeProduct=" + upgradeProduct + "&app=" + app + "&screen=" + screen + "&uniqueId=" + uniqueId + "&modalKey=" + modalKey + "&source=" + source + "&transparent=true";
  var copyMachineVariant = (0, _params.parse)(window.location.search.substring(1))['copy_machine_variant'];

  if (copyMachineVariant) {
    queryParams = queryParams + "&copy_machine_variant=" + copyMachineVariant;
  }

  return "https://" + (0, _getIframeModalHost.getIframeModalHost)() + "/modal/" + _hubspot.default.get() + "?" + queryParams;
}

var ModalContent = _styledComponents.default.div.withConfig({
  displayName: "UpgradeModal__ModalContent",
  componentId: "bft4b7-0"
})(_templateObject());

var LoadingSpinnerContainer = _styledComponents.default.div.withConfig({
  displayName: "UpgradeModal__LoadingSpinnerContainer",
  componentId: "bft4b7-1"
})(_templateObject2());

var LoadingContentContainer = _styledComponents.default.div.withConfig({
  displayName: "UpgradeModal__LoadingContentContainer",
  componentId: "bft4b7-2"
})(_templateObject3());

function LoadingModal(_ref) {
  var frameReady = _ref.frameReady,
      onFrameClose = _ref.onFrameClose;
  return _react.default.createElement(_UIModal.default, {
    width: 950,
    use: "conversational"
  }, !frameReady && _react.default.createElement(LoadingContentContainer, null, _react.default.createElement(_UIAbstractProgress.default, {
    autoStart: true,
    render: function render(_ref2) {
      var value = _ref2.value;
      return _react.default.createElement(_UINanoProgress.default, {
        value: value,
        animateOnComplete: true
      });
    }
  }), _react.default.createElement(_UIDialogCloseButton.default, {
    onClick: onFrameClose
  }), _react.default.createElement(_UIDialogBody.default, null, _react.default.createElement(LoadingSpinnerContainer, null, _react.default.createElement(_UILoadingSpinner.default, {
    size: "small",
    grow: true
  })))), frameReady && _react.default.createElement(ModalContent, null));
}

function UpgradeModal(_ref3) {
  var upgradeData = _ref3.upgradeData,
      modalKey = _ref3.modalKey,
      children = _ref3.children;
  var frameSrc = (0, _react.useRef)(createFrameSrc(upgradeData, modalKey));

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loadFrame = _useState2[0],
      setLoadFrame = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      frameReady = _useState4[0],
      setFrameReady = _useState4[1];

  var eventProperties = (0, _react.useRef)((0, _extends2.default)({}, upgradeData, {
    source: createSource(upgradeData)
  }));
  (0, _react.useEffect)(function () {
    tracker.track('lockedFeatureInteraction', (0, _extends2.default)({
      action: 'viewed'
    }, eventProperties.current));
  }, []);

  var handleClick = function handleClick() {
    setLoadFrame(true);
    tracker.track('lockedFeatureInteraction', (0, _extends2.default)({
      action: 'clicked'
    }, eventProperties.current));
  };

  var onFrameReady = function onFrameReady() {
    setFrameReady(true);
  };

  var onFrameClose = function onFrameClose() {
    setLoadFrame(false);
    setFrameReady(false);
  };

  return _react.default.createElement(_react.default.Fragment, null, children({
    openUpgradeModal: handleClick,
    preloadUpgradeModal: function preloadUpgradeModal() {}
  }), loadFrame && _react.default.createElement(LoadingModal, {
    frameReady: frameReady,
    onFrameClose: onFrameClose
  }), loadFrame && _react.default.createElement(_ModalFrame.default, {
    src: frameSrc.current,
    frameReady: frameReady,
    onFrameReady: onFrameReady,
    onFrameClose: onFrameClose
  }));
}

UpgradeModal.propTypes = {
  upgradeData: _react.PropTypes.object.isRequired,
  modalKey: _react.PropTypes.string.isRequired,
  children: _react.PropTypes.func.isRequired
};
var _default = UpgradeModal;
exports.default = _default;
module.exports = exports.default;